import { render, staticRenderFns } from "./ArtistContractUploadCopy.vue?vue&type=template&id=02b7c41c&scoped=true&"
import script from "./ArtistContractUploadCopy.vue?vue&type=script&lang=js&"
export * from "./ArtistContractUploadCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b7c41c",
  null
  
)

export default component.exports